import ScaleContinuous,{deInterpolateLinear,copyScale}from'./continuous';import interpolateNumber from'../utils/interpolators/number';class ScaleCategory extends ScaleContinuous{constructor(){super(deInterpolateLinear,interpolateNumber)}copy(){return copyScale(this,new ScaleCategory)}}export default ScaleCategory;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/axis/scales/category.js
// module id = null
// module chunks = 